import type { RouteRecordRaw } from 'vue-router'

const authorizationRoutes: RouteRecordRaw[] = [
  {
    path: 'authorization',
    name: 'authorization',
    meta: {
      titleKey: 'routes.authorization.title',
      icon: 'Lock',
      helpKey: 'authorization'
    },
    redirect: { name: 'tenant' },
    children: [
      {
        path: 'tenant',
        name: 'tenant',
        component: () => import('@/views/authorization/Tenant.vue'),
        meta: { titleKey: 'routes.authorization.tenant.title', helpKey: 'tenant' }
      },
      {
        path: 'admin-user',
        name: 'admin-user',
        component: () => import('@/views/authorization/AdminUser.vue'),
        meta: { titleKey: 'routes.authorization.admin-user.title', helpKey: 'admin_user' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/authorization/Role.vue'),
        meta: { titleKey: 'routes.authorization.role.title', helpKey: 'role' }
      },
      {
        path: 'personal',
        name: 'personal',
        component: () => import('@/views/authorization/Personal.vue'),
        meta: { titleKey: 'routes.authorization.personal.title', helpKey: 'personal' }
      }
    ]
  }
]

export default authorizationRoutes
